export default class showChollosManager {
    constructor() {
        this.hotelId = null;
        this.selectGroupChollos = document.querySelector('.group-subchollo [data-filter="chollos"][data-type="hotels"]');
        this.eventDelegation();
    }

    eventDelegation() {
        let container = $('[data-subchollo="content"]');

        container.on('pop-state', (event) => {
            this.closeChollos(container);
            event.stopPropagation();
            event.preventDefault();
        });

        $('[data-sticky="button"]').on('click', () => {
            myApp.browserHistoryManager.addState('[data-subchollo="content"]');
            const itineraryModal = document.querySelector('#itineraryModal');
            const groupHotelModal = document.querySelector('#groupHotel');
            if (itineraryModal) {
                myApp.customModalManager.closeModal('#itineraryModal');
            }
            if (groupHotelModal) {
                myApp.customModalManager.closeModal('#groupHotel');
                var selectorChecked = groupHotelModal.querySelector('[data-entity="modal-body"] .active-item');
                if (selectorChecked) {
                    this.hotelId = selectorChecked.getAttribute('name').split('-')[1]
                }
            }
            this.openChollos(container);
        });

        $('[data-nights-regimes="back"]').on('click', () => {
            myApp.browserHistoryManager.removeState('[data-subchollo="content"]');
            this.closeChollos(container);
        });
    }

    closeChollos(container)
    {
        const sinceContainer = document.querySelector("#sinceContainer");
        this.hotelId = null;
        let hotelModal = $('#groupHotel');
        if (this.selectGroupChollos) {
            this.selectGroupChollos.querySelectorAll('[selected]').forEach((select) => {
                select.removeAttribute('selected');
            })
        }
        hotelModal.find('.active-item').removeClass('active-item pb-9');
        if (sinceContainer) {
            sinceContainer.classList.remove('d-none');
        }
        container.addClass('display-block');
        $('body').removeClass('no-background-overflow');
        $('[data-content="group-sticky-button"]').addClass('visible-xs visible-sm').removeClass('visible-checked');
    }

    openChollos(container)
    {
        container.removeClass('display-block');
        $('body').addClass('no-background-overflow');
        $('[data-content="group-sticky-button"]').removeClass('visible-xs visible-sm').addClass('visible-checked');
        $('[data-subchollo="content"]').scrollTop(0);
        if (this.selectGroupChollos && this.hotelId) {
            this.selectGroupChollos.querySelector('[value="' + this.hotelId + '"]').setAttribute("selected", "selected");
        }
        myApp.chollosFilterer.applyFilters();
    }
}
